import { motion } from "framer-motion";
import {
    FileUp,
    FileSearch,
    Layers,
    Orbit,
    PenTool,
    Calculator,
    ShieldCheck,
    Hammer,
} from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../../lib/motion";
import { WORKFLOW } from "../../lib/product";
import { SectionIntro } from "./shared";

const ICONS = {
    FileUp,
    FileSearch,
    Layers,
    Orbit,
    PenTool,
    Calculator,
    ShieldCheck,
    Hammer,
};

const IntelligentWorkflow = () => (
    <section
        id="workflow"
        data-testid="intelligent-workflow-section"
        className="relative bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <SectionIntro
                testid="workflow-intro"
                align="center"
                eyebrow="THE JOURNEY"
                title="One Intelligent Workflow. Total Clarity."
            />

            <motion.ol
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="relative mt-16 grid gap-10 lg:grid-cols-8 lg:gap-4"
            >
                <span
                    aria-hidden="true"
                    className="absolute left-[22px] top-2 h-[calc(100%-16px)] w-px bg-white/10 lg:hidden"
                />
                <span
                    aria-hidden="true"
                    className="absolute left-0 right-0 top-[22px] hidden h-px bg-white/10 lg:block"
                />
                {WORKFLOW.map((stage) => {
                    const Icon = ICONS[stage.icon];
                    return (
                        <motion.li
                            key={stage.n}
                            variants={fadeUp}
                            data-testid={`workflow-stage-${stage.n}`}
                            className={`relative flex gap-5 pl-14 lg:flex-col lg:items-start lg:gap-0 lg:pl-0 ${
                                stage.active ? "text-accent" : "text-mist"
                            }`}
                        >
                            <span
                                className={`absolute left-0 top-0 z-10 flex h-11 w-11 items-center justify-center border bg-ink lg:static lg:mb-5 ${
                                    stage.active
                                        ? "border-accent/70 text-accent"
                                        : "border-white/15 text-mist"
                                }`}
                            >
                                <Icon
                                    className="h-5 w-5"
                                    strokeWidth={1.4}
                                    aria-hidden="true"
                                />
                            </span>
                            <p
                                className={`font-mono text-[13px] tracking-[0.22em] lg:mb-2 ${
                                    stage.active ? "text-accent" : "text-cad"
                                }`}
                            >
                                {stage.n}
                            </p>
                            <div>
                                <h3
                                    className={`text-[16px] font-semibold ${
                                        stage.active
                                            ? "text-accent"
                                            : "text-white"
                                    }`}
                                >
                                    {stage.title}
                                </h3>
                                <p className="mt-2 max-w-[210px] text-[14px] leading-relaxed text-cad lg:max-w-none">
                                    {stage.copy}
                                </p>
                            </div>
                        </motion.li>
                    );
                })}
            </motion.ol>
        </div>
    </section>
);

export default IntelligentWorkflow;
